export default {
  common: {
    comingSoon: '敬请期待',
    view: '查看',
    show: '显示',
    hide: '隐藏',
    optional: '可选',
    confirmDeleteYes: '是',
    confirmDeleteNo: '否',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    deleteCard: '删除此卡片',
    cancel: '取消',
    confirm: '确定',
    loading: '加载中',
    addSuccess: '添加成功',
    editSuccess: '编辑成功',
    deleteSuccess: '删除成功',
    imageCropTip: '请将图片覆盖整个裁剪区域',
    editPhotoTip: '请调整您的照片位置和大小，通过缩放来实现。然后点击"保存"确认。',
    back: '返回',
    close: '关闭',
    generateShortUrlTip: '生成短链接失败，请稍后重试',
    generateShareUrlTip: '生成分享链接失败，请稍后重试',
    generateQRCodeTip: '生成二维码失败，请稍后重试',
    search: '查询',
    serialNumber: '序号',
    hint: '提示',
    add: '添加',
    custom: '自定义',
    send: '发送',
    fillRequired: '请填写必填项',
    exchangeSuccess: '交换成功',
    exchangeFailed: '交换失败，请稍后重试',
    // 图片裁剪相关
    cropImage: '裁剪图片',
    imageToBeCropped: '待裁剪图片',
    cropperNotInitialized: '裁剪器未初始化',
    cropFailed: '裁剪失败',
    convertImageFailed: '转换图片失败',
    displayText: '展示文本',
    linkCopied: '已复制到剪贴板',
    linkCopiedError: '复制失败，请手动复制',
    linkCopiedErrorTip: '请手动复制',
  },
  navFooterTabber: {
    myECard: '名片',
    home: '首页',
    create: '创建',
    my: '我的',
    createTitle: '创建名片',
    cardDetail: '名片详情',
    cardPreview: '名片预览',
    login: '登录',
    templateManagement: '模板管理',
    maxCardNum: '最大支持创建3张名片',
    companyManagement: '企业管理',
    employeeManagement: '员工管理',
    companyInfo: '企业信息',
    systemManagement: '系统管理',
    userManagement: '用户管理',
    customerManagement: '客户关系管理',
    platformCompany: '企业客户管理',
  },
  home: {
    myCardHolder: '我的名片',
    homeDesc: '管理您的专业形象',
    total: '共',
    businessCards: '已创建的名片',
    startCreate: '创建你的第一张名片',
    startCreateDesc: '快速高效地分享您的最新信息，建立您的联系关系。将初次见面转化为持久的联系。',
    createCardButton: '创建我的第一张名片',
  },
  createCard: {
    createTitle: '创建名片',
    editTitle: '编辑名片',
    templateType: '模板类型',
    selectTemplate: '选择模板',
    Classic: '经典',
    Ribbol: '丝带',
    BigHead: '全屏',
    Landscape: '海报',
    themeColor: '主题颜色',
    livePreview: '实时预览',
    create: '创建',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    confirmDelete: '确定要删除此名片吗？',
    confirmDeleteYes: '是',
    confirmDeleteNo: '否',
    display: '展示',
    color: '颜色',
    black: '黑色',
    white: '白色',
    gray: '灰色',
    green: '绿色',
    blue: '蓝色',
    cardBackground: '实体名片背景',
    physicalCardPreview: '实体名片预览',
    uploadPhysicalCard: '上传制卡背景',
    uploadPhysicalCardBack: '上传制卡背景背面',
    front: '正面',
    back: '背面',
    basicInfo: '基本信息',
    links: '链接',
    prefix: '前缀',
    name: '姓名',
    suffix: '后缀',
    yourName: '您的姓名',
    jobTitle: '职务',
    yourPosition: '您的职务',
    company: '公司',
    yourCompany: '您的公司',
    contactInfo: '联系信息',
    email: '邮箱',
    yourEmail: '您的邮箱',
    selectLinkType: '选择链接类型',
    addLink: '添加链接',
    linkName: '链接名称',
    linkNamePlaceholder: '请输入链接名称',
    linkAddress: '链接地址',
    linkAddressPlaceholder: '请输入链接地址',
    selectIcon: '选择图标',
    mobile: '手机',
    addMobile: '添加手机',
    direct: '直拨',
    addDirect: '添加直拨',
    phone: '座机',
    addPhone: '添加座机',
    yourPhone: '您的电话',
    landline: '座机',
    addLandline: '添加座机',
    yourLandline: '您的座机',
    website: '网站',
    address: '地址',
    yourAddress: '您的地址',
    country: '国家',
    city: '城市',
    postcode: '邮政编码',
    socialMedia: '社交媒体',
    pleaseEnterFullLinks: '请填写完整的链接',
    productIntroduction: '产品介绍',
    wechat: '微信',
    wechatId: '微信号',
    facebook: 'Facebook',
    twitter: 'Twitter (X)',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    pinterest: 'Pinterest',
    youtube: 'YouTube',
    other: '其他',
    channelName: '频道名称',
    newChannel: '新频道',
    profileLink: '频道链接',
    displayText: '显示文本',
    pictureInformation: '图片信息',
    companyLogo: '公司Logo',
    companyLogoDesc: '上传您的公司Logo',
    IDPhoto: '个人照片',
    IDPhotoDesc: '上传您的个人照片',
    nameRequired: '请填写姓名',
    jobTitleRequired: '请填写职务',
    companyRequired: '请填写公司名称',
    emailRequired: '请填写邮箱',
    emailFormatError: '请输入正确的邮箱格式',
    phoneRequired: '请填写电话号码',
    addressRequired: '请填写地址',
    companyLogoRequired: '请上传公司Logo',
    IDPhotoUploadSuccess: '个人照片上传成功',
    companyLogoUploading: '上传中...',
    companyLogoUploadMaxSize: '请上传小于30M的图片',
    companyLogoUploadSuccess: '上传成功',
    companyLogoUploadFormat: '请上传jpg/png格式的图片',
    companyLogoUploadTip: '*推荐使用透明背景的png文件',
    reUpload: '重新上传',
    uploadImage: '上传图片',
    uploadImageDesc: '为了呈现最佳制卡效果，请上传分辨率大于等于 1712 × 1080 像素的 JPG 或 PNG 格式高清图片。',
    physicalCardInfo: '实体卡信息',
    physicalCardInfoDesc: '自定义您的实体名片外观',
    expand: '展开',
    collapse: '收起',
    selectLayout: '选择布局',
    layoutDesc: '选择您的实体名片布局',
    backgroundCategory: '背景分类',
    selectBackground: '选择背景',
    textColor: '文字颜色',
    plainColours: '纯色',
    gradients: '渐变',
    gradientStrips: '渐变条纹',
    geometricBackground: '几何背景',
    bottomLine: '底部线条',
    waves: '波浪',
    geometricLines: '几何线条',
    // white: '白色',
    // black: '黑色',
    // gray: '灰色',
    darkGray: '深灰',
    navy: '藏青',
    darkGreen: '墨绿',
    darkRed: '深红',
    gold: '金色',
    bluePurple: '蓝紫',
    pinkRed: '粉红',
    blueCyan: '蓝青',
    goldOrange: '金橙',
    ocean: '海洋',
    sunset: '日落',
    forest: '森林',
    rainbow: '彩虹',
    blueRed: '蓝红',
    lightGray: '浅灰',
    whiteDots: '白点',
    darkDots: '暗点',
    whiteGrid: '白格',
    darkGrid: '暗格',
    goldLine: '金线',
    blueLine: '蓝线',
    redLine: '红线',
    darkGold: '暗金',
    blueWave: '蓝波',
    greenWave: '绿波',
    orangeWave: '橙波',
    whiteLines: '白线',
    darkLines: '暗线',
    goldLines: '金线',
    blueLines: '蓝线',
    // 产品介绍卡片
    simple: 'Simple',
    socialMediaTitle: 'Social Media',
    productCatalog: 'Product Catalog',
    show: '显示',
    hide: '隐藏',
    image: '图片',
    icon: '图标',
    productIntroductionName: '名称',
    url: '链接',
    description: '描述',
    pleaseEnterDescription: '请输入描述',
    pleaseEnterName: '请输入名称',
    pleaseEnterAddress: '请输入地址',
    selectIconFromProvided: '从提供的图标中选择',
    uploadFile: '上传文件',
    addCustomInfo: '添加自定义信息',
    customInfo: '自定义信息',
    learnMore: '了解更多',
    // 社交媒体平台名称
    prdYoutube: 'YouTube',
    prdFacebook: 'Facebook',
    prdInstagram: 'Instagram',
    prdLinkedIn: 'LinkedIn',
    prdWeibo: '微博',
    prdXiaohongshu: '小红书',
    // 错误提示
    imageFormatError: '仅支持 PNG 和 JPG 格式的图片',
    imageSizeError: '图片大小不能超过 {size}MB',
    fileFormatError: '仅支持 PDF、Word、Excel、PPT 格式的文件',
    fileSizeError: '文件大小不能超过 20MB',
    fileUploadError: '文件上传失败，请重试',
    imageUploadError: '图片上传失败，请重试',
    uploadSuccess: '上传成功',
    // alt 属性翻译
    avatarPreview: '头像预览',
    imagePreview: '图片预览',
    iconPreview: '图标预览',
    requiredLink: '为必填项，请填写',
  },
  /** 链接分类名称 */
  linkCategories: {
    popular: '常用推荐',
    social: '社交媒体',
    messaging: '通讯',
    meeting: '会议',
    payment: '支付',
    video: '视频',
    music: '音乐',
    design: '设计',
    gaming: '游戏',
    other: '其他',
  },
  /** 链接标签名称 */
  linkLabels: {
    phone: '手机',
    address: '地址',
    directCall: '直拨',
    telephone: '座机',
    website: '网站',
    link: '链接',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    facebook: 'Facebook',
    xcom: 'X.com',
    snapchat: 'Snapchat',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    pinterest: 'Pinterest',
    twitch: 'Twitch',
    xing: 'Xing',
    threads: 'Threads',
    weibo: '微博',
    qq: 'QQ',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    discord: 'Discord',
    wechat: '微信',
    line: 'Line',
    signal: 'Signal',
    fax: '传真',
    zoom: 'Zoom',
    teams: 'Teams',
    meet: 'Meet',
    skype: 'Skype',
    webex: 'Webex',
    venmo: 'Venmo',
    paypal: 'PayPal',
    cashapp: 'CashApp',
    zelle: 'Zelle',
    brightcove: 'Brightcove',
    vimeo: 'Vimeo',
    spotify: 'Spotify',
    applemusic: 'Apple Music',
    soundcloud: 'SoundCloud',
    behance: 'Behance',
    dribbble: 'Dribbble',
    psn: 'PSN',
    xboxlive: 'Xbox Live',
    nintendo: 'Nintendo',
    github: 'GitHub',
    calendly: 'Calendly',
    patreon: 'Patreon',
    yelp: 'Yelp',
    microsoftbookings: 'Microsoft Bookings',
  },
  /** 链接输入框占位符 */
  linkPlaceholders: {
    phone: '请输入手机号',
    address: '请输入地址',
    directCall: '请输入直拨号',
    telephone: '请输入座机号',
    website: '请输入网站链接',
    link: '请输入链接',
    instagram: '请输入Instagram链接',
    linkedin: '请输入LinkedIn链接',
    facebook: '请输入Facebook链接',
    xcom: '请输入X.com链接',
    snapchat: '请输入Snapchat链接',
    tiktok: '请输入Tiktok链接',
    youtube: '请输入Youtube链接',
    pinterest: '请输入Pinterest链接',
    twitch: '请输入Twitch链接',
    xing: '请输入Xing链接',
    threads: '请输入Threads链接',
    weibo: '请输入微博链接',
    qq: '请输入QQ号',
    whatsapp: '请输入WhatsApp链接',
    telegram: '请输入Telegram链接',
    discord: '请输入Discord链接',
    wechat: '请输入微信号',
    line: '请输入Line链接',
    signal: '请输入Signal链接',
    fax: '请输入传真号',
    zoom: '请输入Zoom链接',
    teams: '请输入Teams链接',
    meet: '请输入Meet链接',
    skype: '请输入Skype链接',
    webex: '请输入Webex链接',
    venmo: '请输入Venmo链接',
    paypal: '请输入PayPal链接',
    cashapp: '请输入CashApp链接',
    zelle: '请输入Zelle链接',
    brightcove: '请输入Brightcove链接',
    vimeo: '请输入Vimeo链接',
    spotify: '请输入Spotify链接',
    applemusic: '请输入Apple Music链接',
    soundcloud: '请输入SoundCloud链接',
    behance: '请输入Behance链接',
    dribbble: '请输入Dribbble链接',
    psn: '请输入PSN链接',
    xboxlive: '请输入Xbox Live链接',
    nintendo: '请输入Nintendo链接',
    github: '请输入GitHub链接',
    calendly: '请输入Calendly链接',
    patreon: '请输入Patreon链接',
    yelp: '请输入Yelp链接',
    microsoftbookings: '请输入Microsoft Bookings链接',
    required: '必填',
  },
  cardDetail: {
    templatePreview: '模板预览',
    company: '公司',
    address: '地址',
    landline: '座机',
    mobile: '手机号',
    direct: '直拨',
    email: '邮箱',
    website: '网站',
    socialMedia: '社交媒体',
    wechat: '微信',
    facebook: 'Facebook',
    twitter: 'Twitter (X)',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    pinterest: 'Pinterest',
    youtube: 'YouTube',
    confirmDelete: '确定要删除吗？',
    confirmDeleteDesc: '此操作将永久删除此名片，请谨慎操作。',
    editCard: '编辑名片',
    deleteCard: '删除名片',
    saveCard: '保存名片',
    shareLink: '分享链接',
    copyLink: '复制链接',
    generatingCardImage: '正在生成名片图片...',
    cardImageGenerated: '名片图片已生成',
    cardImageGeneratedError: '生成名片图片失败，请稍后再试',
    cardImageGeneratedSuccess: '电子名片',
    shareCard: '分享名片',
    saveToContacts: '保存到通讯录',
    vCardGeneratedSuccess: 'vCard文件已生成，请下载并导入到通讯录',
    vCardGeneratedError: '生成vCard文件失败，请重试',
    readingCard: '正在读取名片...',
    addByCardPage: '通过数字名片页面添加',
    saveFailed: '保存失败，请重试',
    linkCopied: '链接已复制到剪贴板',
    linkCopiedError: '链接复制失败，请手动复制链接',
    linkCopiedErrorTip: '请手动复制链接',
    previewCard: '预览名片',
    savePhysicalCard: '保存制卡名片',
    viewPhysicalBusinessCards: '查看制卡名片',
    pushPhysicalBusinessCards: '推送制卡名片',
    pushPhysicalBusinessCardsSuccess: '制卡名片已推送成功',
    pushPhysicalBusinessCardsError: '制卡名片推送失败，请重试',
    pushPhysicalBusinessCardsErrorTip: '请检查网络连接，并重试',
    pushPhysicalBusinessCardsSuccessTip: '制卡名片已推送成功，请耐心等待',
    pushPhysicalBusinessCardsErrorTip2: '请检查网络连接，并重试',
    terminalScanningTwoDimensionalCodeBusinessCardPrinting: '终端扫描二维码制卡',
    saveContact: '保存联系人',
    exchangeContact: '交换联系人',
    shareYourContact: '把你的联系方式分享给',
    firstName: '名',
    lastName: '姓',
    phoneNumber: '电话',

  },
  my: {
    logOut: '退出登录',
    language: '语言设置',
    chinese: '简体中文',
    english: 'English',
    traditionalChinese: '繁體中文',
    profile: '个人中心',
    changePassword: '修改密码',
    quickActions: '快速操作',
    oldPassword: '旧密码',
    enterOldPassword: '请输入旧密码',
    newPassword: '新密码',
    enterNewPassword: '请输入新密码',
    enterConfirmPassword: '请确认新密码',
    confirmPasswordError: '新密码和确认密码不一致',
    confirmPassword: '确认新密码',
    newPasswordLengthError: '新密码长度不能小于6位',
    samePasswordError: '新密码不能与旧密码相同',
    changePasswordSuccess: '密码修改成功',
    changePasswordFailed: '密码修改失败，请重试',
    oldPasswordError: '旧密码错误',
    logOutSuccess: '退出登录成功',
    logOutConfirm: '退出登录确认',

  },
  login: {
    welcome: '欢迎回来',
    subtitle: '登录以继续使用您的账户',
    subtitleTip: '对于新用户，请输入您的首选电子邮件和新密码进行注册',
    usernamePlaceholder: '请输入用户名或邮箱',
    passwordPlaceholder: '请输入密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    loginButton: '登录/注册',
    login: '登录',
    loggingIn: '登录中...',
    noAccount: '还没有账号？',
    register: '立即注册',
    usernameRequired: '请输入用户名或邮箱',
    passwordRequired: '请输入密码',
    loginSuccess: '登录成功',
    forgotPasswordTip: '忘记密码功能开发中',
    registerTip: '注册功能开发中',
    passwordMinLength: '密码长度不能小于6位',
    loginError: '用户名或密码错误',
    usernameMinLength: '用户名长度不能小于5位',
    brandSlogan: '数字名片 · 智能连接',
    loginErrorTip: '登录失败次数过多，账户已被锁定15分钟',
    usernameOrPasswordErrorTip: '用户名或密码错误',
    remainingAttempts: '剩余 {remaining} 次尝试机会',
    locked: '账户已被锁定，请在 {remaining} 秒后重试',
    signUp: '注册账号',
  },
  register: {
    firstName: '名',
    firstNamePlaceholder: '请输入名',
    firstNameRequired: '请输入名',
    lastName: '姓',
    lastNamePlaceholder: '请输入姓',
    lastNameRequired: '请输入姓',
    email: '邮箱',
    emailPlaceholder: '请输入邮箱',
    emailRequired: '请输入邮箱',
    emailInvalid: '请输入有效的邮箱地址',
    username: '用户名',
    usernamePlaceholder: '请输入用户名',
    usernameRequired: '请输入用户名',
    usernameInvalid: '用户名至少3个字符，只能包含字母、数字和下划线',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    passwordRequired: '请输入密码',
    passwordInvalid: '密码至少6个字符',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    confirmPasswordRequired: '请确认密码',
    passwordMismatch: '两次输入的密码不一致',
    registerButton: '注册',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    emailExists: '该邮箱已被注册',
    usernameExists: '该用户名已被使用',
    registerSuccess: '注册成功！请登录',
  },
  companyInfo: {
    companyName: '公司名称',
    companyNameDesc: '请输入您的公司名称',
    companyAddress: '公司地址',
    companyAddressDesc: '请输入您的公司地址',
    companyLogo: '公司Logo',
    companyLogoDesc: '请上传您的公司Logo',
    entityCardBg: '实体卡背景',
    entityCardBgDesc: '请上传您的实体卡背景',
  },
  employee: {
    employeeName: '员工姓名',
    employeeNameDesc: '请输入员工姓名',
    addEmployee: '添加员工',
    employeeNo: '员工编号',
    employeeNoDesc: '请输入员工编号',
    employeeId: '员工ID',
    name: '姓名',
    nameDesc: '请输入员工姓名',
    department: '部门',
    departmentDesc: '请输入员工部门',
    position: '职务',
    positionDesc: '请输入员工职务',
    mobile: '手机号',
    mobileDesc: '请输入员工手机号',
    email: '邮箱',
    emailDesc: '请输入员工邮箱',
    status: '状态',
    statusDesc: '请选择员工状态',
    statusActive: '在职',
    statusInactive: '离职',
    operation: '操作',
    confirmDelete: '确认删除该员工吗？',
    userExist: '用户已存在',
    emailExist: '邮箱已存在',
    userNotExist: '用户不存在',
  },
  userManagement: {
    username: '用户名',
    usernameDesc: '请输入用户名',
    nickname: '昵称',
    email: '邮箱',
    status: '状态',
    statusActive: '启用',
    statusInactive: '禁用',
    operation: '操作',
    changePassword: '修改密码',
    resetPassword: '重置密码',
    newPassword: '新密码',
    newPasswordDesc: '请输入新密码',
    confirmPassword: '确认密码',
    confirmPasswordDesc: '请再次输入新密码',
    changePasswordSuccess: '修改密码成功',
    changePasswordFailed: '修改密码失败',
    resetPasswordSuccess: '重置密码成功',
    resetPasswordFailed: '重置密码失败',
    passwordLengthError: '密码长度在6到20个字符',
    passwordMismatchError: '两次输入的密码不一致',
    confirmResetPassword: '确认重置该用户的密码吗？',
  },
  customerManagement: {
    pageTitle: '客户管理',
    pageDesc: '管理您的客户联系人',
    name: '姓名',
    namePlaceholder: '请输入姓名',
    company: '公司',
    companyPlaceholder: '请输入公司名称',
    phone: '电话',
    phonePlaceholder: '请输入电话号码',
    email: '邮箱',
    emailPlaceholder: '请输入邮箱地址',
    department: '部门',
    departmentPlaceholder: '请输入部门',
    jobTitle: '职位',
    jobTitlePlaceholder: '请输入职位',
    createDate: '创建日期',
    startDate: '开始时间',
    endDate: '结束时间',
    to: '至',
    reset: '重置',
    add: '新增',
    addCustomer: '新增客户',
    editCustomer: '编辑客户',
    deleteConfirm: '确认删除该客户吗？',
    more: '更多',
    firstName: '名',
    lastName: '姓',
    firstNamePlaceholder: '请输入名',
    lastNamePlaceholder: '请输入姓',
    firstNameRequired: '请输入名',
    lastNameRequired: '请输入姓',
    firstNameMaxLength: '名最多30个字符',
    lastNameMaxLength: '姓最多30个字符',
    phoneRequired: '请输入电话号码',
    phoneFormatError: '请输入正确的电话号码格式',
    companyRequired: '请输入公司名称',
    companyMaxLength: '公司名称最多60个字符',
    emailFormatError: '请输入正确的邮箱格式',
    departmentMaxLength: '部门最多60个字符',
    jobTitleMaxLength: '职位最多60个字符',
  },
  platformCompany: {
    name: '名称',
    namePlaceholder: '请输入企业客户名称',
    email: '邮箱',
    emailPlaceholder: '请输入邮箱',
    phone: '联系电话',
    phonePlaceholder: '请输入联系电话',
    createDate: '创建时间',
    startDate: '开始时间',
    endDate: '结束时间',
    to: '至',
    add: '新增',
    resetSearch: '重置查询',
    companyName: '企业客户名称',
    code: '编号',
    contactName: '联系人',
    contactNamePlaceholder: '请输入联系人',
    operation: '操作',
    addCompany: '新增企业客户',
    editCompany: '编辑企业客户',
    website: '网址',
    websitePlaceholder: '请输入企业网址',
    admins: '企业管理员',
    adminName: '姓名',
    adminNamePlaceholder: '请输入姓名',
    adminEmail: '邮箱',
    adminEmailPlaceholder: '请输入邮箱',
    adminMaxTip: '最多配置3个管理员',
    submit: '提交',
    refill: '重填',
    deleteConfirm: '确定删除该企业客户吗？删除后数据将无法恢复。',
    nameRequired: '请输入企业客户名称',
    nameMaxLength: '企业客户名称最多50个字符',
    contactNameRequired: '请输入联系人',
    contactNameMaxLength: '联系人最多20个字符',
    phoneRequired: '请输入联系电话',
    phoneFormatError: '请输入正确的手机号',
    emailRequired: '请输入邮箱',
    emailFormatError: '请输入正确的邮箱格式',
    websiteMaxLength: '网址最多100个字符',
    adminNameRequired: '请输入管理员姓名',
    adminEmailRequired: '请输入管理员邮箱',
    adminEmailFormatError: '请输入正确的邮箱格式',
  },
  errorCodeMap: {
    tokenExpired: '账户信息已过期或已在别处登录，请重新登录',
    systemException: '系统异常，请请联系管理员',
    systemError: '系统异常，请联系管理员处理',
    networkError: '请检查网络',
    "000000": "数据库查询失败",
    "000001": "数据库添加失败",
    "000002": "数据库修改失败",
    "000003": "数据库删除失败",
    "000004": "数据库查询 为空",
    "000005": "批量插入失败",
    "010000": "连接失败",
    "010001": "发送失败",
    "010002": "接收失败",
    "010003": "发送超时",
    "010004": "接收超时",
    "010005": "feign调用失败",
    "010006": "feign调用超时",
    "010007": "服务限流",
    "010008": "无法从服务注册中心获取服务信息",
    "010009": "发送信息失败",
    "010010": "发送或接收异常",
    "020000": "文件不存在",
    "020001": "文件夹不存在",
    "020002": "无法读取文件",
    "020003": "无法写文件",
    "020004": "保存文件失败",
    "020005": "文件名存在",
    "020006": "文件夹名存在",
    "020007": "未知文件格式.",
    "020008": "转换文件失败.",
    "030000": "内存不足",
    "040000": "参数为空",
    "040001": "参数不合法",
    "040002": "数据验证错误",
    "040003": "无参数更新",
    "040004": "id为空",
    "040005": "数据转换异常",
    "050000": "用户已被邀请",
    "050001": "用户已存在",
    "050002": "未授权",
    "050003": "用户不存在",
    "050004": "邀请码不存在",
    "050005": "未知业务类型",
    "050006": "转换微信支付的xml失败",
    "050007": "解析xml异常",
    "050008": "微信返回错误",
    "050009": "无退款记录",
    "050010": "用户未登录",
    "050011": "验证码不 正确",
    "050012": "验证码失效或不存在",
    "050013": "账户状态异常",
    "050014": "静态化页面错误",
    "050015": "用户未通过审核",
    "050016": "授权信息已存在",
    "050017": "设置商品类失败",
    "050018": "设置商品失败",
    "050019": "设置商品SPU属性失败",
    "050020": "设置商品SKU属性失败",
    "050021": "设置商品图片失败",
    "050022": "设置门店商品失败",
    "050023": "设置规格商品失败",
    "050024": "设置商品套餐失败",
    "050025": "获取商品码失败",
    "050026": "商品、分类已关联",
    "050027": "用户未关联商户",
    "050028": "登录权限已过期",
    "050029": "更新商户登录token失败",
    "050030": "分类、打印机已关联",
    "050031": "支付金额异常",
    "050032": "无消费记录",
    "050033": "退款时间已过期",
    "050034": "退款金额异常",
    "050035": "uuid重复",
    "050036": "数据异 常",
    "050037": "登录失败",
    "050038": "注册失败",
    "050039": "重复消费",
    "050040": "账户或密码错误",
    "050041": "未知交易",
    "050042": "交易金额不足",
    "050043": "交易失败",
    "050044": "订单不存在或失效",
    "050045": "已经被绑定",
    "050046": "存在下级",
    "050047": "名称重复",
    "050048": "上传图片失败 ",
    "050049": "已绑定用户",
    "050050": "商户配置信息不存在",
    "050051": "获取微信小程序登录态失败",
    "050052": "解密数据失败",
    "050053": "ES查询失败",
    "050054": "ES添加失败",
    "050055": "ES修改失败",
    "050056": "ES删除失败",
    "050057": "ES查询为空",
    "050058": "ES删除索引失败",
    "050059": "商户角色为空",
    "050060": "不存在该特色服务的配置",
    "050061": "查询机构信息失败",
    "050062": "获取商户信息失败",
    "050063": "脚本执行失败",
    "050064": "Token失效",
    "050065": "编号已经存在",
    "050066": "待分配数量过大",
    "050067": "内置信息，不能删除",
    "050068": "配置商户信息失败",
    "050069": "该商户存在失败开通记录",
    "050070": "导出文件失败",
    "050071": "执行清分失败",
    "050072": "无清分数据",
    "050073": "缓存数据失败",
    "050074": "执行对账失败",
    "050075": "对账金额异常",
    "050076": "账户已停用",
    "050077": "商户未授权",
    "050078": "用户无权限",
    "050079": "未分配数量小于待分配数量",
    "050080": "设备编码解析失败",
    "050081": "设备编码生产工厂解析失败",
    "050082": "设备编码品牌解析失败",
    "050083": "设备编码类型解析失败",
    "050084": "设备编码批次号解析失败",
    "050085": "设备编码型号解析失败",
    "050086": "设备分配失败",
    "050087": "设备编码为空",
    "050088": "设备编码长度  不正确",
    "050089": "模板已被使用",
    "050090": "人员已被通知组使用",
    "050091": "菜单查询为空",
    "050092": "机构已绑定账号",
    "050093": "账户异常",
    "050094": "原始密码错误",
    "050095": "订单异常，请重新下单",
    "050096": "支付异常",
    "050097": "活动信息异常",
    "050098": "获取用户信息错误",
    "050099": "库存不足",
    "050100": "security_uuid重复",
    "050101": "转入退款",
    "050102": "未支付",
    "050103": "已关闭",
    "050104": "已撤销",
    "050105": "用户支 付中",
    "050106": "支付失败",
    "050107": "数据流关闭异常",
    "050108": "权限已存在",
    "050109": "配置文件为空",
    "050110": "时间格式错误",
    "050111": "开始时间不合法",
    "050112": "结束时间不合法",
    "050113": "活动时间冲突",
    "050114": "活动名称冲突",
    "050115": "场景已关联任务",
    "050116": "场景已关联业务类型",
    "050117": "规则组已关联业务类型",
    "050118": "业务类型已关联任务",
    "050119": "图片不合规",
    "050120": "图片分组不一致",
    "050121": "无法获取应用数据准备脚本信息.",
    "050123": "名称已存在.",
    "050124": "系统内部错误.",
    "050125": "获取卡号失败.",
    "050126": "获取应用密钥失败.",
    "050127": "无法获取加密机脚本信息.",
    "050128": "运算错误.",
    "050129": "密钥分散因子长度有误.",
    "050130": "IP未授权.",
    "050131": "获取加密机信 息失败",
    "050132": "获取RSA秘钥规则失败",
    "050133": "获取TK失败",
    "050134": "获取系统LMK索引失败",
    "050135": "获取应用信息异常",
    "050136": "获取应用密钥信息异常",
    "050137": "获取秘钥索引等信息异常",
    "050138": "获取秘钥索引为空",
    "050139": "获取发卡行证书为空",
    "050140": "从加密机获取发卡行秘钥信息失败!",
    "050141": "获取对称秘钥信息失败",
    "050142": "获取对称AC秘钥信息失败",
    "050143": "从加密机获取秘钥失败!",
    "050144": "获取应用绑定的秘钥信息失败",
    "050145": "获取密钥规则失败",
    "050146": "获取未使用的IC卡非对称密钥失败",
    "050147": "获取发卡行索引失败",
    "050148": "从加密机获取ic卡非对称密钥信息失败",
    "050149": "应用已绑定密钥，请解绑后删除",
    "050150": "应用下子应用秘钥存在已绑定密钥，请解绑后删 除!",
    "050151": "应用不符合绑定条件",
    "050152": "密钥不符合绑定条件",
    "050153": "此加密机已被设置的密钥绑定，不能时除!",
    "050154": "加密机厂商下有正在使用的加密机不允许删除",
    "050155": "密钥已绑定，请解绑后再删除!",
    "050156": "密钥下子密钥存在已绑定应用，请解绑后删除!",
    "050157": "该应用已经配置了密钥池",
    "050158": "获取应用配置已关闭",
    "050159": "应用绑定类型异常!",
    "050160": "更新绑定的密钥状态失败!",
    "050161": "密钥绑定类型异常",
    "050162": "应用密钥名称已存在!",
    "050163": "创建绑定的子密钥信息失败!",
    "050164": "应用已绑定，请解绑后再编辑!",
    "050165": "规则已绑定，不允许删除",
    "050166": "添加定时任务信息失败!",
    "050167": "删除定时任务信息失败!",
    "050168": "此应用已配置任务信息，不能重复配  置",
    "050169": "未绑定加密机",
    "050170": "获取CA信息异常",
    "990000": "未知错误信息",
    "060100": "名片不存在",
    "060101": "名片不存在或已下线",
    "060102": "名片已下线或不可用",
    "060103": "名片未发布，无法分享",
    "060104": "无权分享该名片",
    "060105": "生成QR码失败",
    "060106": "已经收藏过该名 片",
    "060107": "收藏失败",
    "060108": "未找到收藏记录",
    "060109": "取消收藏失败",
    "060200": "邮箱已存在", // 用户名已存在
    "060201": "企业注册失败",
    "060202": "用户不存在",
    "060203": "企业不存在",
    "060204": "无权查看该企业信息",
    "060205": "更新企业信息失败",
    "060206": "无权操作其他企业",
    "060207": "操作用户不存在",
    "060208": "无权操作",
    "060209": "员工编号已存在",
    "060210": "添加员工失败",
    "060211": "用户未关联企业",
    "060212": "只有企业管理员可以执行此操作",
    "060213": "员工不存在",
    "060214": "该员工不属于此企业",
    "060215": "该用户不是企业员工",
    "060216": "无权查看该企业员工列表",
    "060217": "更新员工信息失败",
    "060218": "管理员用户创建失败",
    "060300": "method参数不能为空",
    "060301": "未知的API",
    "060400": "refresh token无效或已过期",
    "060401": "无效的refresh token",
    "060402": "refresh token已被使用或不存在",
    "060403": "请求体错误",
    "060404": "请求路径不允许",
    "060405": "请求方法为空",
    "060406": "授权请求头错误",
    "060407": "令牌为空",
    "060408": "令牌无效",
    "060409": "令牌解析错误",
    "060411": "无效请求",
    "060412": "缺少时间戳或签名",
    "060413": "请求已过期",
    "060414": "重复请求"
  }
}